import React from 'react';
import '../user-login/UserLogin.scss';

const DISNEY_BRAND_LOGOS = [
    {
        src: 'https://imagedelivery.net/YCD7tVM32nZsH5l1bbP2EQ/8d697813-99ca-41bf-40d5-b9fc1ae74200/w=800',
        alt: 'Disney Cruise Line',
        className: 'user-login__disney-logo user-login__disney-logo--cruise'
    },
    {
        src: 'https://imagedelivery.net/YCD7tVM32nZsH5l1bbP2EQ/a097e8a1-30b2-408f-759b-b240f24c8900/w=800',
        alt: 'Walt Disney World Resort Florida',
        className: 'user-login__disney-logo user-login__disney-logo--resort'
    }
];

const DISNEY_CHARACTER_IMAGE = 'https://imagedelivery.net/YCD7tVM32nZsH5l1bbP2EQ/83048b1a-b44e-40a4-05ab-536c507f3500/w=800';

const DisneyHero = ({ className = '', showBrandRow = true, showCopy = true, showCharacters = true }) => {
    const heroClassName = ['user-login__disney-hero', className].filter(Boolean).join(' ');

    return (
        <div className={heroClassName}>
            <div className="user-login__disney-cloud user-login__disney-cloud--top" />
            {showBrandRow &&
            <div className="user-login__disney-brand-row">
                {DISNEY_BRAND_LOGOS.map((logo) => (
                    <img
                        key={logo.alt}
                        className={logo.className}
                        src={logo.src}
                        alt={logo.alt}
                    />
                ))}
            </div>
            }

            <div className="user-login__disney-stage">
                {showCopy &&
                <div className="user-login__disney-copy">
                    <p className="user-login__disney-welcome">Welcome to the</p>
                    <h1 className="user-login__disney-title">AOP FY27</h1>
                    <p className="user-login__disney-subtitle">Collaboration Station</p>
                </div>
                }

                {showCharacters &&
                <div className="user-login__disney-characters-wrap">
                    <img
                        className="user-login__disney-characters"
                        src={DISNEY_CHARACTER_IMAGE}
                        alt="Toy Story 5 characters"
                    />
                </div>
                }
            </div>
        </div>
    );
};

export default DisneyHero;